import { Component, OnInit } from '@angular/core';
import { SimulationQuery } from '../state/simulation.query';

@Component({
  selector: 'app-simulation-debug-params',
  templateUrl: './simulation-debug-params.component.html',
  styleUrls: ['./simulation-debug-params.component.scss']
})
export class SimulationDebugParamsComponent implements OnInit {

  parametersErrors$ = this.simulationQuery.parametersErrors$;

  constructor(
    private simulationQuery: SimulationQuery
  ) { }

  ngOnInit(): void { }

  printAll(parametersErrors: any) {
    console.error(JSON.stringify(parametersErrors, null, 4));
  }

}
